import { formatDistanceToNowStrict, max, sub } from "date-fns";

import { assessmentTemplate as ar1001Prescreen } from "../assets/assessments/ar1001Prescreen";
import { assessmentTemplate as careFirstWeight } from "../assets/assessments/careFirstWeight";
import { assessmentTemplate as eos5Pillars } from "../assets/assessments/eos5Pillars";
import { assessmentTemplate as eosBusinessInformation } from "../assets/assessments/eosBusinessInformation";
import { assessmentTemplate as eosOnboarding } from "../assets/assessments/eosOnboarding";
import { assessmentTemplate as hyperOnboard } from "../assets/assessments/hyperOnboard";
import { assessmentTemplate as independentFunction } from "../assets/assessments/independentFunction";
import { assessmentTemplate as omniHealthHistory } from "../assets/assessments/omniHealthHistory";
import { assessmentTemplate as omniHealthHistoryDemo } from "../assets/assessments/omniHealthHistoryDemo";
import { assessmentTemplate as omniMedicationReminderDemo } from "../assets/assessments/omniMedicationReminderDemo";
import { assessmentTemplate as omniMSOnboard } from "../assets/assessments/omniMSOnboard";
import { assessmentTemplate as pcrHairLoss } from "../assets/assessments/pcrHairLoss";
import { assessmentTemplate as phq9 } from "../assets/assessments/phq9";
import constants from "../assets/constants";
import * as OmniDataModel from "../data/omniDataModel";

export const getAssessmentTemplateByType = assessmentType => {
  //this must contain every assessmeent type ever supported
  switch (assessmentType) {
    case constants.assessmentIDs.ar1001Prescreen:
      return ar1001Prescreen[0];
    case constants.assessmentIDs.omniHealthHistory:
      return omniHealthHistory[0];
    case constants.assessmentIDs.independentFunction:
      return independentFunction[0];
    case constants.assessmentIDs.phq9:
      return phq9[0];
    case constants.assessmentIDs.careFirstWeight:
      return careFirstWeight[0];
    case constants.assessmentIDs.pcrHairLoss:
      return pcrHairLoss[0];
    case constants.assessmentIDs.eos5Pillars:
      return eos5Pillars[0];
    case constants.assessmentIDs.eosBusinessInformation:
      return eosBusinessInformation[0];
    case constants.assessmentIDs.eosOnboarding:
      return eosOnboarding[0];
    case constants.assessmentIDs.omniMSOnboard:
      return omniMSOnboard[0];
    case constants.assessmentIDs.omniMedicationReminderDemo:
      return omniMedicationReminderDemo[0];
    case constants.assessmentIDs.omniHealthHistoryDemo:
      return omniHealthHistoryDemo[0];
    case constants.assessmentIDs.hyperOnboard:
      return hyperOnboard[0];
    default:
      return null;
  }
};

export const getOnboardingLabelFromAssessmentType = assessmentType => {
  switch (assessmentType) {
    case constants.assessmentIDs.ar1001Prescreen:
      return "AR-1001";
    case constants.assessmentIDs.omniHealthHistory:
      return "OH: History";
    case constants.assessmentIDs.independentFunction:
      return "OH: Ind. Function";
    case constants.assessmentIDs.phq9:
      return "PHQ-9";
    case constants.assessmentIDs.careFirstWeight:
      return "CF: Weight Loss";
    case constants.assessmentIDs.pcrHairLoss:
      return "PCR: Hair Loss";
    case constants.assessmentIDs.eos5Pillars:
      return "EOS: 5 Pillars";
    case constants.assessmentIDs.eosBusinessInformation:
      return "EOS: Business Information";
    case constants.assessmentIDs.eosOnboarding:
      return "EOS: Onboarding";
    case constants.assessmentIDs.omniMSOnboard:
      return "OH: MS Onboard";
    case constants.assessmentIDs.omniMedicationReminderDemo:
      return "OH: Medication Reminder";
    case constants.assessmentIDs.omniHealthHistoryDemo:
      return "OH: Health History Demo";
    case constants.assessmentIDs.hyperOnboard:
      return "HW: Onboarding";
    default:
      return assessmentType ? assessmentType : "(Org Default)";
  }
};

export const createOmniPaginationObject = (valueSeed = null, defaultPageSize = 20) => {
  //if we need defaults we can add them
  let theReturn = {
    pageIndex: 1,
    totalItems: 0,
    pageSize: defaultPageSize,
    sort: {},
    query: {},
    invalidateCache: false,
  };
  if (valueSeed != null) {
    theReturn.pageIndex = valueSeed.pageIndex;
    theReturn.totalItems = valueSeed.totalItems;
    theReturn.pageSize = valueSeed.pageSize;
    theReturn.query = valueSeed.query;
  }
  return theReturn;
};

export const getReportOnlyFields = (
  reportTypeValue,
  includePatientFields = false,
  assessmentType = null,
) => {
  let onlyFields = [];

  //Unique ID
  onlyFields.push("_id");

  if (reportTypeValue === constants.reportTypeEnums.patientForOrganization) {
    //CANDIDATE REPORT
    //Audit Fields
    onlyFields.push("omniAudit.modifiedDate");
    onlyFields.push("omniAudit.createdDate");
    onlyFields.push("omniAudit.isActive");
    //UserData - Name
    onlyFields.push("omniData.displayName");
    onlyFields.push("omniData.nameTitle");
    onlyFields.push("omniData.givenName");
    onlyFields.push("omniData.middleName");
    onlyFields.push("omniData.familyName");
    onlyFields.push("omniData.nameSuffix");
    //UserData - Contact
    onlyFields.push("omniData.mobilePhone");
    onlyFields.push("omniData.email");
    onlyFields.push("omniData.preferredAlertMethod");
    //UserData - Demographics
    onlyFields.push("omniData.birthdate");
    onlyFields.push("omniData.gender");
    onlyFields.push("omniData.race");
    onlyFields.push("omniData.ethnicity");
    //address
    onlyFields.push("omniData.address.streetAddress");
    onlyFields.push("omniData.address.locality");
    onlyFields.push("omniData.address.region");
    onlyFields.push("omniData.address.postalCode");
    onlyFields.push("omniData.address.country");
    //Patient Data
    let patientData = OmniDataModel.createNewPatientData();
    for (var prop in patientData) {
      if (Object.prototype.hasOwnProperty.call(patientData, prop)) {
        onlyFields.push(`omniData.patientData.${prop}`);
      }
    }
  } else if (reportTypeValue === constants.reportTypeEnums.invites) {
    //INVITE
    onlyFields.push("omniAudit.modifiedDate");
    onlyFields.push("omniAudit.createdDate");
    onlyFields.push("omniAudit.isActive");

    let inviteData = OmniDataModel.createNewInvite();
    for (let propC in inviteData.omniData) {
      if (propC !== "userData") {
        onlyFields.push(`omniData.${propC}`);
      }
    }
    onlyFields.push(`omniData.inviteKey`);
    onlyFields.push(`omniData.invitationStatus`);

    //UserData - Name
    onlyFields.push("omniData.userData.givenName");
    onlyFields.push("omniData.userData.familyName");
    // //UserData - Contact
    onlyFields.push("omniData.userData.mobilePhone");
    onlyFields.push("omniData.userData.email");
  } else if (reportTypeValue === constants.reportTypeEnums.communications) {
    //Audit Fields
    onlyFields.push("omniAudit.modifiedDate");
    onlyFields.push("omniAudit.createdDate");
    onlyFields.push("omniAudit.isActive");

    onlyFields.push("omniData.batchId");
    onlyFields.push("omniData.sendDate");
    onlyFields.push("omniData.sendResult");
    onlyFields.push("omniData.description");
    onlyFields.push("omniData.communicationType");
    onlyFields.push("omniData.communicationTarget");
    onlyFields.push("omniData.communicationTemplateId");
    onlyFields.push("omniData.destinatons.to.partnerIds");
    onlyFields.push("omniData.destinatons.to.partnerQuery");
    onlyFields.push("omniData.destinatons.to.inviteIds");
    onlyFields.push("omniData.destinatons.to.inviteQuery");
  } else if (reportTypeValue === constants.reportTypeEnums.users) {
    // User Report
    //Audit Fields
    onlyFields.push("omniAudit.modifiedDate");
    onlyFields.push("omniAudit.createdDate");
    onlyFields.push("omniAudit.isActive");
    //UserData - Name
    onlyFields.push("omniData.displayName");
    onlyFields.push("omniData.nameTitle");
    onlyFields.push("omniData.givenName");
    onlyFields.push("omniData.middleName");
    onlyFields.push("omniData.familyName");
    onlyFields.push("omniData.nameSuffix");
    //UserData - Contact
    onlyFields.push("omniData.mobilePhone");
    onlyFields.push("omniData.email");
    onlyFields.push("omniData.preferredAlertMethod");
    //UserData - Demographics
    onlyFields.push("omniData.birthdate");
    onlyFields.push("omniData.gender");
    onlyFields.push("omniData.race");
    onlyFields.push("omniData.ethnicity");
    //address
    onlyFields.push("omniData.address.streetAddress");
    onlyFields.push("omniData.address.locality");
    onlyFields.push("omniData.address.region");
    onlyFields.push("omniData.address.postalCode");
    onlyFields.push("omniData.address.country");

    if (includePatientFields) {
      let patientData = OmniDataModel.createNewPatientData();
      for (var aProp in patientData) {
        if (Object.prototype.hasOwnProperty.call(patientData, aProp)) {
          onlyFields.push(`omniData.patientData.${aProp}`);
        }
      }
    }
  } else if (reportTypeValue === constants.reportTypeEnums.assessments) {
    // User Report
    //Audit Fields
    onlyFields.push("omniAudit.modifiedDate");
    onlyFields.push("omniAudit.createdDate");
    onlyFields.push("omniAudit.isActive");
  }

  return onlyFields;
};

export const getIdByRelationshipType = (relatedData, omniRelationshipType) => {
  try {
    const filtered = relatedData.filter(
      element => element.omniRelationshipType === omniRelationshipType,
    );

    if (filtered.length > 0) {
      return filtered[0]._id;
    }
  } catch (error) {
    console.log(error);
  }
  return null;
};

export const getUserDescription = userOdm => {
  let theReturn = "";
  //don't judge me, i know this is a shit comparison

  if (
    userOdm.omniData.race &&
    !userOdm.omniData.race.toLowerCase().includes("prefer") &&
    !userOdm.omniData.race.toLowerCase().includes("unsure")
  ) {
    let theRace = constants.userRaceOptions.find(race => race.value === userOdm.omniData.race);

    if (theRace !== undefined) {
      if (theReturn.length > 0) {
        theReturn += "  ";
      }
      theReturn += theRace.label;
    }
  }

  if (
    userOdm.omniData.gender &&
    !userOdm.omniData.gender.toLowerCase().includes("prefer") &&
    !userOdm.omniData.gender.toLowerCase().includes("unsure")
  ) {
    if (theReturn.length > 0) {
      theReturn += "  ";
    }
    theReturn += capitalizeAllWords(userOdm.omniData.gender);
  }

  let age = getAgeFromDateString(userOdm.omniData.birthdate);
  if (age !== 0) {
    if (theReturn.length > 0) {
      theReturn += ",  ";
    }
    theReturn += `Age ${getAgeFromDateString(userOdm.omniData.birthdate)}`;
  }

  if (theReturn.length === 0) {
    theReturn = "Click edit to update information!";
  }
  return theReturn;
};

export const getCommunicationTemplateDescription = communicationTemplateODM => {
  let theReturn = communicationTemplateODM.omniData.name;

  if (communicationTemplateODM.omniData.overrideEmailSource) {
    theReturn += ` (${communicationTemplateODM.omniData.overrideEmailSource})`;
  } else {
    if (
      communicationTemplateODM.omniData.communicationTarget ===
      constants.communicationTargets[0].value
    ) {
      theReturn += ` (Invitees)`;
    } else {
      theReturn += ` (Patners)`;
    }
  }
  return theReturn;
};

export const getReportDescription = reportODM => {
  let theReturn = "";

  let theType = constants.reportTypes.find(obj => obj.value === reportODM.omniData.reportType);

  if (theType !== undefined) {
    theReturn += theType.label;
  }

  if (reportODM.omniData.status === "ready") {
    if (reportODM.omniData.rows) {
      if (theReturn.length > 0) {
        theReturn += ":  ";
      }
      if (reportODM.omniData.reportType === constants.reportTypeEnums.patientForOrganization) {
        theReturn += `${reportODM.omniData.rows} Candidate`;
      } else if (reportODM.omniData.reportType === constants.reportTypeEnums.invites) {
        theReturn += `${reportODM.omniData.rows} Invitation`;
      } else if (reportODM.omniData.reportType === constants.reportTypeEnums.communications) {
        theReturn += `${reportODM.omniData.rows} Communication Request`;
      } else {
        //user request
        if (reportODM.omniData.hasOwnProperty("userType")) {
          theReturn += `${reportODM.omniData.rows} ${capitalizeAllWords(
            reportODM.omniData.userType,
          )}`;
        } else {
          theReturn += `${reportODM.omniData.rows} User`;
        }
        //   }
        // } else {
        //   theReturn += `: ${capitalizeAllWords(reportODM.omniData.status)}`;
      }
      if (reportODM.omniData.rows.length !== 1) {
        theReturn += `s`;
      }
    }
  }

  if (theReturn.length === 0) {
    theReturn = "Uh oh...";
  }
  return theReturn;
};

export const OmniStringToDate = dateString => {
  try {
    if (dateString.length <= 10) {
      //to local timezone
      dateString = dateString + "T00:00:00";
    }
    return new Date(dateString);
  } catch (error) {
    console.log("Date Conversion Error: " + dateString);

    return new Date();
  }
};

export const isValidUUID = uuid => {
  try {
    const regexExp =
      /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi;
    return regexExp.test(uuid); // true
  } catch (error) {
    console.log("IsValidUUID Error: It wasn't even a string you idiot");
    return false;
  }
};

export const capitalizeAllWords = text => {
  text = text
    .toLowerCase()
    .split(" ")
    .map(s => s.charAt(0).toUpperCase() + s.substring(1))
    .join(" ");
  return text;
};

export const deepCopyObject = copyFrom => {
  return JSON.parse(JSON.stringify(copyFrom));
};

export const formatIsoDateString = (dateString, short = true) => {
  let aDate = OmniStringToDate(dateString);

  const longDateOptions = {
    weekday: "long",
    year: "numeric",
    month: "short",
    day: "numeric",
  };

  const shortDateOptions = {
    year: "numeric",
    month: "short",
    day: "numeric",
  };

  return aDate.toLocaleDateString("en-US", short ? shortDateOptions : longDateOptions);
};

export const getDaysOld = dateString => {
  let aDate = OmniStringToDate(dateString);
  var diff_ms = Date.now() - aDate.getTime();
  return Math.floor(diff_ms / (1000 * 60 * 60 * 24));
};

export const getAgeFromDateString = dateString => {
  let aDate = OmniStringToDate(dateString);
  var diff_ms = Date.now() - aDate.getTime();
  var age_dt = OmniStringToDate(diff_ms);
  return Math.abs(age_dt.getUTCFullYear() - 1970);
};

export const helperGetIsoDate = (days = 0, inThePast = true, makeTimeInclusive = false) => {
  try {
    const dayOffsetTime = 24 * 60 * 60 * 1000;

    var d = new Date();
    if (inThePast) {
      d.setTime(d.getTime() - dayOffsetTime * days);
      if (makeTimeInclusive) {
        d.setHours(0, 0, 0, 1);
      }
    } else {
      d.setTime(d.getTime() + dayOffsetTime * days);
      if (makeTimeInclusive) {
        d.setHours(23, 59, 59, 999);
      }
    }

    return d.toISOString();
  } catch (error) {
    return Date.now().toISOString();
  }
};

export const millisecondsStringToHoursTimeString = ms => {
  try {
    const getMilliseconds = `0${(ms % 1000) / 10}`.slice(-2);
    const seconds = Math.floor((ms / 1000) % 60);
    const getSeconds = `0${seconds}`.slice(-2);
    const minutes = Math.floor((ms / 60000) % 60);
    const getMinutes = `0${minutes}`.slice(-2);
    const hours = (ms / 3600000).toFixed(0);
    return `${hours}:${getMinutes}:${getSeconds}.${getMilliseconds}`;
  } catch (error) {
    console.log("Time Conversion Error: " + ms);
    return 0;
  }
};

export const millisecondsStringToMinutesTimeString = ms => {
  try {
    const getMilliseconds = `0${(ms % 1000) / 10}`.slice(-2);
    const seconds = Math.floor((ms / 1000) % 60);
    const getSeconds = `0${seconds}`.slice(-2);
    const minutes = (ms / 60000).toFixed(0);
    return `${minutes}:${getSeconds}.${getMilliseconds}`;
  } catch (error) {
    console.log("Time Conversion Error: " + ms);
    return 0;
  }
};

export const millisecondsStringToSecondsTimeString = ms => {
  try {
    const seconds = (ms / 1000).toFixed(2);
    return `${seconds}`;
  } catch (error) {
    console.log("Time Conversion Error: " + ms);
    return 0;
  }
};

export const isValidEmail = email => {
  //eslint-disable-next-line
  var re =
    //eslint-disable-next-line
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  return re.test(String(email).toLowerCase());
};

export const loadJSONDataFromURL = async dataURL => {
  //TODO find!ak
  try {
    const result = await fetch(dataURL);
    const json = await result.json();
    const theRet = await JSON.parse(json);

    return theRet;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const getElapsedTimeString = (startDate, endDate, postPend = "ago") => {
  let diff = Math.floor(startDate.getTime() - endDate.getTime());
  let day = 1000 * 60 * 60 * 24;

  let days = Math.floor(diff / day);
  let months = Math.floor(days / 31);
  let years = Math.floor(months / 12);

  if (years > 0) {
    let theReturn = years;
    theReturn += " year";
    if (years !== 1) {
      theReturn += "s";
    }
    let remainingMonths = months - 12 * years;
    if (remainingMonths > 2) {
      theReturn += " and " + remainingMonths + " months";
    }
    theReturn += " " + postPend;
    return theReturn;
  } else if (months === 1) {
    return "Last Month";
  } else if (months > 0) {
    let theReturn = months + " months";
    theReturn += " " + postPend;
    return theReturn;
  } else if (days === 1) {
    return "Yesterday";
  } else if (days > 0) {
    let weeks = Math.round(days / 7);
    if (weeks === 1) {
      return "Last week";
    } else if (weeks > 1) {
      let theReturn = weeks + " weeks";
      theReturn += " " + postPend;
      return theReturn;
    } else {
      let theReturn = days + " days";
      theReturn += " " + postPend;
      return theReturn;
    }
  } else {
    return "Today";
  }
};

export const getDateRangeCaption = (arr, rng) => {
  arr.sort();
  let startDate = new Date(arr[0]);

  let subDate = new Date(
    rng === "short"
      ? sub(Date.now(), { months: 3 })
      : rng === "medium"
        ? sub(Date.now(), { months: 6 })
        : startDate,
  );

  return `Last ${formatDistanceToNowStrict(max([startDate, subDate]))}`;
};

export const getDateRangeTitleText = (startDate, endDate, showElapsed = true) => {
  let dateString = `${constants.monthNames[startDate.getMonth()]} ${startDate.getDate()} - ${endDate.getMonth() !== startDate.getMonth() ? constants.monthNames[endDate.getMonth()] : ""} ${endDate.getDate()}`;

  if (startDate.getFullYear() !== endDate.getFullYear()) {
    dateString += ` ${endDate.getFullYear()}`;
  }

  if (showElapsed) {
    let diff = Math.floor(endDate.getTime() - startDate.getTime());
    let day = 1000 * 60 * 60 * 24;

    let days = Math.ceil(diff / day);
    dateString += ` (${days} Days)`;
  }

  return dateString;
};

export const generateCSVData = objectArray => {
  try {
    const keys = Object.keys(objectArray[0]);
    // Build header
    let result = keys.join(",") + "\n";
    // Add the rows
    objectArray.forEach(obj => {
      result += keys.map(k => obj[k]).join(",") + "\n";
    });
    return result;
  } catch (error) {
    return "";
  }
};

export const generateBotpressCSVData = objectArray => {
  try {
    let keys = Object.keys(objectArray[0]);
    keys = keys.filter(key => key !== "computed" && key !== "stale");
    // Build header
    let result = keys.join(",") + "\n";

    // Add the rows
    //todo add support for quoted responses
    objectArray.forEach(obj => {
      result += keys.map(k => obj[k]).join(",") + "\n";
    });
    return result;
  } catch (error) {
    return "";
  }
};
const formatBlock = aBlock => {
  let aBlockText = "";

  if (aBlock.type === "text" || aBlock.type === "quick_reply") {
    aBlockText += aBlock.text;
  } else if (aBlock.type === "choice") {
    aBlockText += `${aBlock.text}`;
  } else if (aBlock.type === "bubble") {
    if (aBlock.block.text !== "") {
      aBlockText += `${aBlock.block.text}\n`;
    }
  } else if (aBlock.type === "row") {
    aBlockText += `BUTTONS: `;
    for (let index = 0; index < aBlock.blocks.length; ++index) {
      if (index !== 0) {
        aBlockText += " | ";
      }
      aBlockText += `${aBlock.blocks[index].text}`;
    }
  } else {
    aBlockText += `Media aBlock of type ${aBlock.type}\n`;
  }

  return aBlockText;
};

export const formatMessage = message => {
  let messageText = "";

  try {
    if (message.payload.hasOwnProperty("block")) {
      messageText += formatBlock(message.payload.block);
    } else {
      for (let index = 0; index < message.payload.blocks.length; ++index) {
        messageText += formatBlock(message.payload.blocks[index]);
      }
    }
  } catch (error) {
    messageText = error.toString;
  }
  return messageText + "\n\n";
};

export const createConversationJSON = (botID, userData, webchatConfig, messages) => {
  let conversation = {
    title: "Omnisia Conversation",
    creationData: new Date().toISOString(),
    userData: userData,
    displayIdentifier: "Company-bot",
    harnessFolder: "",
    botId: botID,
    webchatConfig: webchatConfig,
    messages: messages,
  };
  return JSON.stringify(conversation, null, 2);
};

export const getThemeFromURL = currentRoute => {
  switch (currentRoute) {
    case constants.appPaths.appPathVisionsDemo:
      return 4;
    default:
      return 0;
  }
};

function isObject(item) {
  return item && typeof item === "object" && !Array.isArray(item);
}

export const deepMerge = (target, ...sources) => {
  if (!sources.length) return target;
  const source = sources.shift();

  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      if (isObject(source[key])) {
        if (!target[key]) Object.assign(target, { [key]: {} });
        deepMerge(target[key], source[key]);
      } else {
        Object.assign(target, { [key]: source[key] });
      }
    }
  }

  return deepMerge(target, ...sources);
};
